import { ResponseSupportsProductyTypes } from '@core/types/login';
import { ProductTypeEnum } from './productType';

/**
 * @desc 所有站点 locales
 */
export type SiteType = 'eu' | 'us';
export type LanguageType = 'en' | 'zh' | 'de' | 'fr' | 'it' | 'es';
export type LocaleType = 'en_US' | 'zh_CN' | 'de_DE' | 'fr_FR' | 'it_IT' | 'es_ES';

export type SitesDataType = {
    lang: LanguageType; // 语言
    locale: LocaleType; // 地区语言
    label: string; // 名称
    recaptcha: string; // Google 人机语言映射
};

export type LocalesConfigType = {
    sites: SiteType[];
    sitesData: SitesDataType[];
};

const { sites, sitesData } = process.env.LOCALES_CONFIG as unknown as LocalesConfigType;

export const SITES = sites;
export const SITES_DATA = sitesData;

// console.log('_sites ===', sites);
// console.log('_sitesData ===', sitesData);
/**
 * @desc 站点映射域名
 */
export const SITE_MAP: { [key in SiteType]: string } = {
    eu: process.env.API_HOST_EU || '',
    us: process.env.API_HOST_US || '',
};

// 人机校验密钥
export const SECRET_KEY = process.env.RECAPTCHA_REGISTER_SECRET_KEY;

/**
 * @desc 应用类型
 */
export enum GLOBAL_APP_ENUM {
    USER_APP = 'USER_APP', // 用户版入口
    INSTALLER_APP = 'INSTALLER_APP', // 服务商入口
    DEVELOPMENT_APP = 'DEVELOPMENT_APP', // 研发版入口
}

export type GlobalAppType = keyof typeof GLOBAL_APP_ENUM;

export const GLOBAL_APP = ((window as any).GLOBAL_APP as GlobalAppType) || 'INSTALLER_APP';

export const AGREEMENT_LANGUAGE_TYPE: { [key in LanguageType]: string } = {
    zh: 'zh-cn',
    en: 'en-us',
    de: 'de-de',
    fr: 'fr-fr',
    it: 'it-it',
    es: 'es-es',
};

/**
 * 站点支持产品映射
 * @returns
 */
export const SUPPORTS_PRODUCT_TYPES = (): { [key in SiteType]: ResponseSupportsProductyTypes } => ({
    eu: [String(ProductTypeEnum.JT303), String(ProductTypeEnum.DC303), String(ProductTypeEnum.JT321)],
    us: [String(ProductTypeEnum.PD303)],
});

export const SUPPORTS_PRODUCT_TYPES_FOR_PRO = (): { [key in SiteType]: ResponseSupportsProductyTypes } => ({
    eu: [String(ProductTypeEnum.JT303), String(ProductTypeEnum.DC303), String(ProductTypeEnum.JT321)],
    us: [String(ProductTypeEnum.YJ751)],
});

/**
 * @desc 定义默认数据中心
 */
export const DEFAULT_SITE: SiteType = 'eu';

/**
 * @desc 定义默认语言环境
 */
export const DEFAULT_LANG: LanguageType = 'en';
